export default "__VITE_ASSET__w0DkTDaG__"